<template>
  <div class="add-baby">
    <m-loading :loading="loading"></m-loading>
    <div class="baby-infos">
      <div class="input">
        <van-field
          input-align="right"
          clickable
          name="name"
          required
          v-model="formData.name"
          label="学生姓名"
          :maxlength="15"
          error-message-align="right"
          :error-message="validate.fieldMsg.name"
          :style="{ marginBottom: '20px' }"
        />

        <van-field
          input-align="right"
          readonly
          required
          clickable
          :value="sex"
          name="sex"
          label="学生性别"
          placeholder="点击选择性别"
          @click="showSelect"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="[
              {
                text: '男',
                value: 1
              },
              {
                text: '女',
                value: 2
              }
            ]"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          input-align="right"
          readonly
          required
          clickable
          v-model="formData.birthday"
          name="cardType"
          label="出生日期"
          placeholder="点击选择出生日期"
          error-message-align="right"
          :error-message="validate.fieldMsg.name"
          @click="showtypeBirthday"
        />
        <van-popup v-model="showBirthday" position="bottom">
          <van-datetime-picker
            type="date"
            title="选择年月日"
            :value="birthdayDate"
            :min-date="minDate"
            :max-date="new Date()"
            @cancel="showBirthday = false"
            @confirm="getbirthday"
          />
        </van-popup>
        <van-field readonly disabled input-align="right" clickable name="age" v-model="formData.age" type="digit" label="年龄" placeholder="选择出生日期自动生成"/>
        
		  <van-field
		    input-align="right"
		    readonly
		    clickable
        required
		    :value="cardType"
		    name="cardType"
		    label="证件类型"
		    placeholder="点击选择证件类型"
		    @click="showtypeSelect"
		  />
		  <van-popup v-model="showtypePicker" position="bottom">
		    <van-picker
		      show-toolbar
		      :columns="[
		        {
		          text: '内地',
		          value: 0
		        },
		        {
		          text: '港澳台及外籍',
		          value: 1
		        }
		      ]"
		      @confirm="ontypeConfirm"
		      @cancel="showtypePicker = false"
		    />
		  </van-popup>
        <van-field
          input-align="right"
          v-model="idCardNo"
          required
          label="证件号码"
          :maxlength="formData.cardType==0?18:null"
          placeholder="证件号码"
        />
        <!-- 头像 -->
        <van-field label-class="affixs-label">
          <template #label>
            <span
              class="custom-title"
              error-message-align="right"
              :error-message="validate.fieldMsg.head"
              >学生头像</span>
            <span class="custom-tit">(jpg/png格式最多一张，每张不超过3M)</span>
          </template>
        </van-field>
        <div class="baby-head">
          <van-uploader
            :before-delete="headBeforeDel"
            v-model="head"
            :max-count="1"
            :before-read="uploadBeforeRead"
          />
        </div>
      </div>
      <div class="tips">请确保信息无误后提交，30天内仅能修改一次</div>
      <div class="submit">
        <van-button size="large" @click="submitFn" color="linear-gradient(to right, #5DD682, #5AFF8E)">
          {{ edit ? "保存修改" : "提交认证" }}
        </van-button>
        <van-button v-if="edit" size="large" @click="getUnbind" color="linear-gradient(to right, red,red)" style="margin-top:10px">
          解绑学生
        </van-button>
      </div>
    </div>
    <van-dialog className='repeatDialog' v-model="repeatShow" show-cancel-button cancel-button-text='不是' confirm-button-text='是我的孩子，绑定' @confirm='getbinding'>
      <div class="institutionName" v-if="repeatData.imgsArr&&repeatData.imgsArr.length>0">
        最近一次报名作品
      </div>
      <div class="idTab" v-for="(ks,index) in repeatData.imgsArr" :key="index">
        <div class="overallBetween">
          <div class="fileName">{{ks.fileType==1?'图片':ks.fileType==2?'音频':ks.fileType==3?'视频':ks.fileType==4?'文档':''}}文件： {{ks.fileName}}</div>
          <a style="color: rgb(55, 117, 246)" @click.stop="getcheck(ks)">查看</a>
        </div>
      </div>
      <!-- <div class="institutionName" v-if="repeatData.institutionName">
        在{{repeatData.institutionName}}报名
      </div> -->
      <div class="babyInfo">
        <div class="overallLeft">
          <div class="babyInfo-name1">{{repeatData.name}}</div>
          <div class="babyInfo-name2">{{repeatData.sex==1?'男':'女'}},{{repeatData.age}}岁</div>
        </div>
        <div class="babyInfo-name3">{{repeatData.idCardNo}}</div>
      </div>
    </van-dialog>
    <van-popup v-model="checkType" class="photo-tags" closeable position="bottom" :style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
      <div class="show-photo-tags">
        <img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
        <audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls :src="checkData.fileUrl"></audio>
        <video ref="videoPlayer" v-if="checkData.fileType == 3"  width="100%" height="200" controls :src="checkData.fileUrl"></video>
        <p style="text-align: center; margin-top: 20px">
          <a style="font-size: 18px; color: #16d77a" v-if="checkData.fileType == 4" :href="checkData.fileUrl">
            点击查看文档类作品
          </a>
        </p>
      </div>
    </van-popup>
    <Crop
      :popup.sync="compressShow"
      :img="compressImg"
      @close="cancelUpload"
      @getImageData="uploadHead"
    />
  </div>
</template>

<script>
import { checkUploadFile,getfileTypeArr } from "@/utils/tool";
import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
import {getGrowAge} from "@/utils/yearOld";
import {
  addUserBaby,
  uploadImg,
  getNewUserBabyDetails,
  updUserBaby,
  unbindParent,
  userBindBaby
} from "@/utils/api/user";
import { Dialog } from 'vant';
import { localStorageGetItem } from "@/utils/auth";
export default {
  mixins: [validate],
  components: {
    Crop
  },
  data() {
    return {
      loading: true,
      // 头像
      head: [],
      // 需要提交的表单信息
      formData: {
        head: null,
        name: "",
        sexVal: null,
        birthday:'',
        age: null,
        teacher: "",
        teacher_phone: ""
      },
      cardType:'',
      showtypePicker:false,
      idCardNo: null,
      primaryIdCardNo:null,
      // 性别
      sex: null,
      // 展示选择性别
      showPicker: false,
      // 报名服务单位类型 0报名服务单位报名服务单位虚拟报名服务单位
      orgType: 0,
      // 显示选择报名服务单位
      showOrganization: false,
      // 省份 最开始进入页面定位或者选择
      province: "",
      // 报名服务单位列表
      organizationList: [],
      compressShow: false,
      compressImg: "",
      edit: true, // false添加 true修改
      babyId: null,

      showBirthday:false,
      birthdayDate:new Date(),
      maxDate: new Date(),
      minDate: new Date(),
      repeatShow:false,
      repeatData:{
        babyInfo:{}
      },
      checkType:false,
      checkData:{},
    };
  },
  mounted() {
    let date = new Date()
    let Y = date.getFullYear();
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
    let D = (date.getDate() < 10 ? '0'+date.getDate(): date.getDate());
    let TENANTID = localStorageGetItem("TENANT-ID") || "0";
    this.minDate = TENANTID>0? new Date((Y-90), M, D):new Date((Y-30), M, D);
    const mode = this.$route.query.mode;
    this.edit = parseInt(mode) == 1;
    this.validate.setFormDataKey("formData");
    this.province = this.$store.state.addressInfos.province;
    if (this.edit) {
      this.babyId = this.$route.query.id;
      document.title = "编辑学生";
      this.getBabyDetail();
    }else{
      this.loading = false;
    }
  },
  methods: {
    /**
     * @description:  查看文件
     * @param {*} ks
     * @author: wangxiaoheng
     */
     getcheck(ks){
      this.checkData = ks;
      this.checkType = true;
    },
    // 获取宝贝详情
    getBabyDetail() {
      // getUserBabyDetails
      getNewUserBabyDetails(this.babyId).then((res) => {
        if (res.success) {
          const data = res.data;
          this.formData = {
            age: data.birthday?getGrowAge(data.birthday).gapYear:data.age,
            head: data.imgUrl,
            birthday:data.birthday,
            organizationVal: data.institutionId,
            name: data.name,
            province: data.province || this.province,
            sexVal: data.sex,
            teacher: data.teacherName,
            teacher_phone: data.teacherTel
          };
          data.birthday&&(this.birthdayDate = new Date(data.birthday));
          console.log(this.birthdayDate)
          this.idCardNo = data.idCardNo;
          this.primaryIdCardNo = data.idCardNo;
          if(data.idCardType==0||data.idCardType==1){
            this.cardType = data.idCardType == 0 ? "内地" : "港澳台及外籍";
            this.formData.cardType = data.idCardType
          }
          if (data.imgUrl) {
            this.head = [
              {
                url: data.imgUrl,
                status: "done"
              }
            ];
          }
          this.sex = data.sex == 1 ? "男" : data.sex == 2 ? "女" : "";
          this.loading = false;
        }
      });
    },
    listAddUser(action, done) {
      if (action === "confirm") {
        // 确认
        if (this.orgType) {
          if (!this.formData.organizationVal) {
            this.$root.$toast.fail("请填写信息");
            done(false); // 关闭提⽰框
            return;
          }
        } else {
          if (
            !this.formData.organizationVal ||
            !this.formData.teacher ||
            !this.formData.teacher_phone
          ) {
            this.$root.$toast.fail("请填写信息");
            done(false); // 关闭提⽰框
            return;
          }
		      const res = this.formData.teacher_phone.length == 11;
          if (!res) {
            this.$toast.fail("请输入正确的手机号");
            done(false); // 关闭提⽰框
            return;
          }
        }
        done(); // 关闭提⽰框
      } else if (action === "cancel") {
        // 取消
        done(); // 关闭提⽰框
      }
    },
    showSelect() {
      this.showPicker = true;
    },
    /**
     * @description: 打开出生日期选择弹框
     * @param {*}
     * @return {*}
     * @author: wangxiaoheng
     */
    showtypeBirthday(){
      this.showBirthday = true;
    },
    getbirthday(date){
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let D = (date.getDate() < 10 ? '0'+date.getDate(): date.getDate());
      this.formData.birthday = Y+M+D;
      this.formData.age = getGrowAge( this.formData.birthday).gapYear;
      this.ageLimit(this.formData.age)
      this.birthdayDate = date;
      this.showBirthday = false;
    },
    // 年龄限制
    ageLimit(val) {
      if (parseInt(val) > 30) {
        this.formData.age = 30;
      }
      if (parseInt(val) < 1) {
        this.formData.age = 1;
      }
    },
    showtypeSelect() {
      this.showtypePicker = true;
    },
    // 上传前预处理
    uploadBeforeRead(file) {
      this.compressImg = URL.createObjectURL(file);
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShow = true;
    },
    /**
     * @description: 关闭音视频
     * @param {*} index
     * @author: wangxiaoheng
     */
     beforeCloseHandler(){
      if(this.$refs.audioPlayer){
        this.$refs.audioPlayer.pause();
        this.$refs.audioPlayer.currentTime = 0;
      }
      if(this.$refs.videoPlayer){
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
    },
    cancelUpload() {
      this.compressShow = false;
      this.head = [];
    },
    // 上传头像
    async uploadHead(file) {
      const pass = checkUploadFile({ file, size: 3 }, (err) => {
        this.$root.$toast.fail(err);
        this.head = [
          {
            url: "",
            message: "图片大于3m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.head = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData.head = url;
      } else {
        this.head = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },
    // 删除已经上传的头像
    headBeforeDel() {
      this.formData.head = null;
      return true;
    },
    // 性别选择确定
    onConfirm(item) {
      this.sex = item.text;
      this.formData.sexVal = item.value;
      this.showPicker = false;
    },
    ontypeConfirm(item){
      this.cardType = item.text;
      this.idCardNo=null;
      this.formData.cardType = item.value;
      this.showtypePicker = false;
    },
    /**
     * @description: 解除绑定
     * @author: wangxiaoheng
     */
    getUnbind(){
      Dialog.confirm({
        title: '是否确认解除绑定学生？',
        message: '信息录入错误可进行修改，解除绑定后无法获得学生参赛信息且30天内不能绑定其他学生，是否确认？',
        confirmButtonText:'确认解绑'
      }).then(() => {
        unbindParent({id:this.babyId}).then((res) => {
          if (res.success) {
            this.$root.$toast.success({
              duration: 2000,
              message: "解除绑定成功",
              onClose: () => {
                this.$router.go(-1);
              }
            });
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    // 提交数据
    async submitFn() {
      let formData = {};
      // 验证数据
      // 性别，头像，学校非必填
      // 性别只能提交一次
      // 选择报名服务单位后 指导老师，指导导师电话必填
      const dataValidate = () => {
        return new Promise((res) => {
          for (let key in this.formData) {
            let val = this.formData[key];
            const unMust = ["sexVal", "head"];
            if (
              !unMust.includes(key) &&
              !(key === "teacher" || key === "teacher_phone")
            ) {
              let pass = this.validate.isNull(key);
              console.log('pass',pass,val,key)
              if (!pass)  res(false);
              formData[key] = val;
            } else if (unMust.includes(key)) {
              formData[key] = val;
            }
            if (key === "teacher" || key === "teacher_phone") {
              res(true);
            }
            this.$forceUpdate();
          }
        });
      };
      let result = await dataValidate();
      console.log('测试',result)
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        if(this.formData.cardType !=0 &&this.formData.cardType !=1){
          this.$root.$toast.fail("请选择证件类型");
          return
        }
        if(this.formData.cardType==0||this.formData.cardType==1){
          if (!this.idCardNo) {
            this.$root.$toast.fail("请填写证件号码");
            return;
          }
        }
        if (this.idCardNo) {
          if (!this.formData.sexVal) {
            return  this.$root.$toast.fail("请选择学生性别");
          }
          if(this.formData.cardType!=0&&this.formData.cardType!=1){
            this.$root.$toast.fail("请选择证件类型");
            return;
          }
        }
        if (!this.formData.birthday) {
          this.$root.$toast.fail("请选择学生出生年月");
          return;
        }
        let idCardNo = this.primaryIdCardNo == this.idCardNo?'':this.$cryptojs.encryptionBase64(this.idCardNo);
        let p = {
          idCardNo: idCardNo,
          birthday:this.formData.birthday,
          age: this.formData.age,
          imgUrl: this.formData.head,
          institutionId: this.formData.organizationVal,
          name: this.formData.name,
          province: this.province,
          sex: this.formData.sexVal,
          teacherName: this.formData.teacher,
		      idCardType:this.formData.cardType,
          teacherTel: this.formData.teacher_phone
        };
        if (p.organizationVal == 0) {
          delete p.organizationVal;
        }
        if (this.edit) {
          p.id = this.babyId;
          updUserBaby(p).then((res) => {
            if(res.code == 40127){
              res.data.babyInfo = res.data.babyInfo&&JSON.parse(res.data.babyInfo)
              res.data.imgsArr = getfileTypeArr(res.data.imgs)
              this.repeatData = res.data;
              this.repeatShow = true;
            }else if (res.success) {
              this.$root.$toast.success({
                duration: 2000,
                message: "修改成功",
                onClose: () => {
                  this.$router.go(-1);
                }
              });
            }
          });
        } else {
          addUserBaby(p).then((res) => {
            if(res.code == 40127){
              res.data.babyInfo = res.data.babyInfo&&JSON.parse(res.data.babyInfo)
              res.data.imgsArr = getfileTypeArr(res.data.imgs)
              this.repeatData = res.data;
              this.repeatShow = true;
            }else if (res.success) {
              this.$root.$toast.success({
                duration: 2000,
                message: "添加成功",
                onClose: () => {
                  this.$router.go(-1);
                }
              });
            }
          });
        }
      }
    },
    // 查看作品
    viewImage(img) {
      this.$root.$ImagePreview([img]);
    },
    getFileType(fileName) {
      let urlType = fileName.slice(-(fileName.length - fileName.lastIndexOf(".") - 1));
      let imgType = ".jpg,.png,.jpeg";
      let audioType = ".mp3,.wav,.ogg,.mpeg";
      let videoType = ".mp4,.avi,mov";
      let fileType = ".doc,.docx";
      if (imgType.indexOf(urlType) !== -1) {
        return 1
      }
      if (audioType.indexOf(urlType) !== -1) {
        return 2
      }
      if (videoType.indexOf(urlType) !== -1) {
        return 3
      }
      if (fileType.indexOf(urlType) !== -1) {
        return 4
      }
    },
    /**
     * @description: 绑定
     * @author: wangxiaoheng
     */
    getbinding(){
      let bindWorksValue = {
        // 宝贝Id
        babyId:this.repeatData.id,
      }
      if(this.babyId){
        bindWorksValue.updateBabyId = this.babyId;
        Dialog.confirm({
          title: '确认弹框',
          message: `请确认该身份证号${this.idCardNo}是您孩子的，即将进行数据合并，合并后无法分离。`,
        }).then(() => {
          this.getrequest(bindWorksValue)
        }).catch(() => {
        });
      }else{
        this.getrequest(bindWorksValue)
      }
    },
    getrequest(bindWorksValue){
      userBindBaby(bindWorksValue).then((res) => {
        if (res.success && res.code==20000) {
          this.repeatShow = false;
          if(res.data&&res.data.code===1){
            Dialog.confirm({
              title: '学员被绑定',
              message: res.data.message,
            }).then(() => {
              this.$router.go(-1);
            }).catch(() => {});
          }else{
            this.$root.$toast.success({
              duration: 2000,
              message: "绑定成功",
              onClose: () => {
                this.$router.go(-1);
              }
            });
          }
        } else {
          let left = this;
          setTimeout(()=>{
            left.$root.$toast.fail("绑定失败"+res.data||res);
          },1)
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.add-baby {
  background-color: #f9f9f9;
  height: 100%;
  .baby-infos {
    // padding: 0 20px;
    // background-color: #fff;
    .input {
      .custom-title {
        color: #646566;
        // &::before {
        //   margin-left: -48px;
        //   content: "*";
        //   color: #ee0a24;
        //   margin-right: 2px;
        // }
      }
      .custom-tit {
        font-size: 12px;
        color: #ccc;
      }
      .baby-head {
        text-align: left;
      }
    }
    .tips {
      text-align: center;
      font-size: 12px;
      color: #999;
      margin: 0 auto;
      margin-top: 30px;
    }
    .submit {
      margin: 20px auto;
      .van-button {
        border-radius: 16px;
        width: 254px;
        height: 32px;
        .van-button__text {
          font-size: 14px;
        }
      }
    }
  }
}
.repeat-title{
  margin: 20px 0px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #404046;
}
.imgType{
  max-width: 245px;
  max-height: 138px;
  margin: 0 auto;
}
.institutionName{
  margin: 13px auto;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FF7856;
}
.babyInfo{
  width: 245px;
  min-height: 64px;
  background: rgba(131, 227, 143, 0.1);
  border-radius: 6px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 6px;
  padding: 13px;
}
.babyInfo-name1{
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #404046;
  margin-right: 20px;
}
.babyInfo-name2{
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #404046;
}
.babyInfo-name3{
  text-align: left;
  margin-top: 11px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #404046;
}
.idTab{
  padding: 2px 4px;
  font-size: 12px;
}
.fileName{
  width: 250px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.van-popup.photo-tags {
  background-color: unset;
  .checkClass{
    width: 8.1067rem;
    border-radius: 0.4267rem;
    overflow: hidden;
    margin-top: 5vh;
    display: flex;
  }
  .show-photo-tags {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    p {
      font-size: 14px;
      text-align: center;
      color: #f2f2f2;
    }
    img {
      width: 304px;
      border-radius: 16px;
      overflow: hidden;
      margin-top: 5vh;
      display: flex;
    }
  }
}
.add-baby {
  .baby-infos {
    .input {
      .van-cell {
        &::after {
          border: none;
        }
        .affixs-label {
          width: unset;
          & + .van-field__value {
            display: none;
          }
        }
      }
      .baby-head {
        text-align: left;
        background-color: #fff;
        .van-uploader {
          @include from-upload-style;
        }
      }
    }
  }
}
.repeatDialog{
  .van-button__content{
    background: #F7F7FA !important;
    .van-button__text{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
    }
  }
  .van-hairline--left{
    .van-button__content{
      background: #83E38F !important;
      .van-button__text{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
      }
    }
  }

}
</style>
